import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import * as usersActions from '../../store/users/actions';
import { initializeList } from '../../store/lists/actions';
import * as reducers from '../../store/reducers';

const getDisplayName = WrappedComponent => {
  return WrappedComponent.displayName || WrappedComponent.name || 'Component';
};

export default function withClassStudents(WrappedComponent) {
  class DecoratedComponent extends React.Component {
    componentDidMount() {
      const { classId } = this.props.match.params;
      this.props.fetchStudentsInClassIfNeeded(classId);
      this.props.initializeList(
        'students_in_class',
        `students_in_class_${classId}`
      );
    }

    render() {
      if (!this.props.list) return null;
      const newProps = {
        ...this.props,
        ...this.state,
      };
      return <WrappedComponent {...newProps} />;
    }
  }

  DecoratedComponent.displayName = `withClassStudents(${getDisplayName(
    WrappedComponent
  )})`;

  const mapStateToProps = (state, { match: { params } }) => {
    return {
      list: reducers.getClassListById(state, params.classId),
    };
  };

  return withRouter(
    connect(mapStateToProps, { ...usersActions, initializeList })(
      DecoratedComponent
    )
  );
}
